import React, { useState } from "react";
import { Stack, Typography } from "@mui/material";
import CustomSimpleAccordion from "qubCommon/Accordions/CustomSimpleAccordion";
import TerminationDialog from "./TerminationDialog";
import TerminationSummaryTable from "./TerminationSummaryTable";
import { DoneAll } from "@mui/icons-material";

const Termination = ({ data, fetchClearings, seasonId }) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [previewData, setPreviewData] = useState([]);
  const [selectedType, setSelectedType] = useState(null);

  const applicationSummary = [
    { id: 1, label: "Τρίτεκνες Μητέρες", submitted: 502, approved: 310, rejected: 92, status: "Σε Έλεγχο" },
    { id: 2, label: "Πολύτεκνες Μητέρες", submitted: 280, approved: 240, rejected: 18, status: "Σε Επεξεργασία" },
    { id: 3, label: "Επιτυχόντες Πανελλαδικών", submitted: 370, approved: 300, rejected: 42, status: "Ολοκληρωμένος" },
  ];

  const handleOpenDialog = (appType) => {
    setSelectedType(appType || null);
    console.log(appType);
    setOpenDialog(true);
  };

  const handleConfirmOpen = () => {
    setOpenConfirm(true);
  };

  const handleUpdate = () => {
    console.log("✅ Updating checks for:", selectedType, previewData);
    setOpenConfirm(false);
    setOpenDialog(false);
  };

  const AccordionTitle = () => (
    <Stack direction="row" gap={1}>
      <DoneAll color="primary" fontSize="small" sx={{ marginLeft: "2px" }} />
      <Typography variant='h4' color="primary" sx={{ fontWeight: 700 }}>
        Ολοκλήρωση Διαδικασίας Ελέγχου
      </Typography>
    </Stack>
  );

  return (
    <CustomSimpleAccordion
      defaultOpen
      title={<AccordionTitle />}
      content={
        <Stack spacing={2}>


          {/* Summary Table */}
          <TerminationSummaryTable rows={data} onOpenDialog={handleOpenDialog} />

          {/* Dialogs */}
          <TerminationDialog
            open={openDialog}
            seasonId={seasonId}
            onClose={() => setOpenDialog(false)}
            applicationType={selectedType}
            onConfirm={handleConfirmOpen} // 🔹 opens confirmation dialog
            onConfirmSuccess={fetchClearings}
          />


        </Stack>
      }
    />
  );
};

export default Termination;
